import React from 'react'
import { IoCheckmarkSharp } from "react-icons/io5";
import { FaRankingStar } from "react-icons/fa6";
import { WiStars } from "react-icons/wi";
import second from '../../Assets/second.png'


import bg from '../../Assets/Background.jpg'
import cx from '../../Assets/CX.png';
import bs from '../../Assets/businessmanagement.png';
import rs from '../../Assets/review-management.png';
import sm from '../../Assets/social-media.png';
import cm from '../../Assets/Campaigns.png';
import messg from '../../Assets/messagingmanagement .png';
import ticket from '../../Assets/ticketing.png';
import contact from '../../Assets/contact-management.png';
import payment from '../../Assets/Paymentsmanage.png';
import ads from '../../Assets/Ads.png';


import integrate from '../../Assets/integrate.png';
import halfintegrate from '../../Assets/halfintegration .png';










import { FaStar } from "react-icons/fa";
import { MdStars } from "react-icons/md";
import { IoIosStar } from "react-icons/io";
import { FcGoogle } from "react-icons/fc";
import Footer from './Footer';
import Clients from './Clients';
import Compliance from './Compliance';
import Booking from './Booking';
import Branding from './Branding';
import { useNavigate } from 'react-router-dom';

function Home() {
    const navigate = useNavigate();

    const card = [
        {
            image: bs, 
            title: 'Business Management',
            des: 'Streamline, and oversee key business processes to enhance efficiency. Gain control over operations, automate tasks, and  ensure optimal business growth and success.',
    
        },
        {
        image: rs, 
        title: 'Review Management',
        des: 'Increase sales by collecting, monitoring, analyzing, and responding to customer reviews with the help of AI.',
        // link: ''

    },
 
    {
        image: sm, 
        title: 'Social Media Management',
        des: 'Automate, schedule, analyze, manage social media activity to increase brand awareness, engagement and track performance.',

    },
    {
        image: cm, 
        title: 'Campaign Management',
        des: 'SMS, Email and WhatsApp. These tools allow businesses to create, automate delivery messages, track results and generate valuable insights.',

    },
    {
        image: messg, 
        title: 'Omnichannel communication',
        des: 'Businesses save time and resources by streamlining their messaging efforts, reach customers, make data-driven decisions and improve ROI.',

    },
    {
        image: ticket, 
        title: 'Ticketing Management',
        des: 'Transform reviews, social comments, and survey responses into support tickets, allowing you to address issues proactively before they escalate.',

    },
    {
        image: contact, 
        title: 'Contact Center Management',
        des: 'Efficiently oversee contact center operations, enhance customer service, and optimize communication strategies for seamless engagement and satisfaction',

    },
    {
        image: ads, 
        title: 'Ads Personalization',
        des: 'Tailor ads to individual preferences, deliver personalized experiences, and boost engagement through targeted advertising strategies',

    },
    {
        image: payment, 
        title: 'Payments Management',
        des: 'Simplify financial transactions, manage payments securely, and optimize financial processes for streamlined operations and business success.',

    },
]

  return (
    <div className='pt-[20px] sm:pt-[85px]  gap-[70px] flex flex-col items-center min-h-full w-full overflow-x-hidden'>
        {/* FIRST SECTION */}
      <div style={{
            backgroundImage: `url(${bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            
            boxShadow:' 0px 0px 30px -15px rgba(30,70,246,1)',
        }}  className="border w-full lg:w-[87%] min-h-[550px] 2xl:w-[78%] lg:rounded-2xl flex flex-col lg:flex-row overflow-clip">  
            <div className='w-full lg:w-[50%] p-10 flex flex-col gap-6'>     
            <div className='w-full  flex flex-col gap-6'>     
            <span className='flex items-center gap-2 semibold text-white '><MdStars />Improve CE / CX</span>  
            <span className=' slide-in-bottom bold text-[28px] lg:text-[32px] xl:text-[38px] 2xl:text-[44px]   sm:leading-[45px] xl:leading-[55px] 2xl:leading-[65px] text-white'>Know your customers</span>  

</div>
<span className='regular slide-in-bottom-d text-white text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] leading-[26px] lg:leading-[36px] '>
    Know your every customer via 1:1 interaction. 
     Simplify customer engagement. Make it easy for customers to get help when needed.
     

            </span>
            <span className=' italics text-white text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] leading-[26px] lg:leading-[36px] slide-in-bottom-e '> " Your customers have high expectations — and if your business can't meet them, they're going to leave you for your competitors." </span>
            <span className=' text-white text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] leading-[26px] lg:leading-[36px] semibold  slide-in-bottom-f'>It's harsh, yes, but the truth.</span>

            <button onClick={() => navigate('/waitlist')}  className="flex items-center gap-2 text-sm w-max  sm:text-[14px]  tracking-wide rounded-lg hover:shadow hover:bg-[#1e46f6f6] hover:ring-[2px] hover:ring-blue-200 bold px-3 py-2 sm:px-5 border sm:p-[12px] bg-[#1e47f6] border-[#1e47f6] text-white hover:transition hover:delay-200">
  <span className="button-content medium">Get Started Free</span>
</button>
            </div> 
         <div   style={{
        background: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '0px',
        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
        backdropFilter: 'blur(2px)',
        WebkitBackdropFilter: 'blur(5px)',
        border: '1px solid rgba(255, 255, 255, 0.3)',
      }} className='w-full lg:w-[50%] flex justify-center items-center lg:px-10'>
        <img className='lg:rounded-3xl  lg:border-blue-200 lg:border-[1px] aspect-auto' src={cx} alt="" />
         </div>
      </div>

      <div className='bold  text-[22px] sm:text-[50px] lg:text-[60px] xl:text-[72px] 2xl:text-[80px] mt-5 lg:mt-9 2xl:mt-14 gradient-bg bg-clip-text text-transparent '>
       Communicate . Engage . Elevate
      </div>
              {/* Second SECTION */}

      <div   className="w-[90%] lg:w-[85%] 2xl:w-[78%] h-max lg:min-h-[620px] mt-9 xl:mt-11 pt-5 flex flex-col lg:flex-row gap-6 lg:gap-3">       
         <div className='w-full lg:w-[40%] flex flex-col gap-5 justify-start lg:justify-center h-full'>
            <div>     
            <span className='flex items-center gap-1 semibold text-blue-700 '><FaRankingStar /> Get started</span>  
            <span className='bold text-[28px] lg:text-[32px] xl:text-[38px] 2xl:text-[44px]   sm:leading-[45px] xl:leading-[55px] 2xl:leading-[65px] '>Everything you need<br />
                to grow your business</span>    
</div>
           
            <span className='regular text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] leading-[26px] lg:leading-[36px] '>Simplify customer experience. One platform for
                    business management, reviews, social media, ads, marketing, and service.
                    Build a consistent brand voice that customers love.
            </span>
            <div className='flex flex-wrap xl:flex-nowrap items-center text-xs xl:text-sm  2xl:text-[16px] gap-3'>
                <span className='flex items-center gap-2 semibold'><IoCheckmarkSharp className='text-blue-700 ' /> Try for free</span>
                <span className='flex items-center gap-2 semibold'><IoCheckmarkSharp className='text-blue-700 ' /> No credit card required</span>

                <span className='flex items-center gap-2 semibold'><IoCheckmarkSharp className='text-blue-700 ' /> Cancel anytime</span>

                </div>
                
                <button  className="flex items-center gap-2 text-sm w-max  sm:text-[14px]  tracking-wide rounded-lg hover:shadow hover:bg-[#1e46f6f6] hover:ring-[2px] hover:ring-blue-200 bold px-3 py-2 sm:px-5 border sm:p-[12px] bg-[#1e47f6] border-[#1e47f6] text-white hover:transition hover:delay-200">
  <span className="button-content medium">Get Started Free</span>
</button>
         </div>
         <div className=' w-full lg:w-[60%] lg:pl-10 '>
            <img src={second} className='w-[90%]  aspect-auto' alt="" />
            

         </div>
      </div>


     {/* Third SECTION */}

                 <Clients />


      {/* 4TH SECTION */}
      <div  className=" w-[78%] flex flex-col gap-10 mt-24 items-center">       
        <span className='bold text-[20px] sm:text-[24px] lg:text-[30px] 2xl:w-[80%] text-center'>A comprehensive platform for engagement,marketing and communication, designed for businesses</span>
        <div className=' w-screen p-2 flex justify-center flex-wrap gap-10 xl:p-[5%] 2xl:px-[20%]'>
            {card?.map((e) => (
                  <div className='h-[370px] w-[340px]  lg:h-[432px] lg:w-[400px] border rounded-xl overflow-clip'>
                  <div className='h-[45%] flex justify-center object-cover bg-gray-100 '>
                    <img className='h-full  aspect-auto ' src={e?.image} alt="" />
                  </div>
                  <div className='h-[45%]'>
                      <div className='flex flex-col gap-6 pt-5 px-3'>
                         <span className="bold text-[17px]">{e.title}</span> 
                         <span className='text-sm text-gray-800'>{e.des}</span> 
      
                      </div>
                  </div>
                  <div className='h-[10%] px-3'>
                  <span className="text-[13px] text-blue-600 medium">Explore {e.title}</span> 
      
                  </div>
      
                 </div>
            ))}
         
       
        </div>
      </div>

      {/* 5th section */}
      <div  className="w-[90%] lg:w-[85%] 2xl:w-[78%] flex flex-col gap-10 mt-24 items-center">       
        <span className='bold text-[20px] sm:text-[24px] lg:text-[30px] text-center'>Integrate Elyzian with your favourite platforms</span>
        <span className=' text-sm sm:text-base lg:text-[17px] text-center w-full lg:w-[60%]'>Elyzian seamlessly integrates with more than 100+ platforms, simplifying the process of automatically acquiring new reviews, enhancing online visibility, engaging with all customers, and boosting revenue.</span>

        <div className=' w-screen flex justify-center bg-[#eeecea]'>
           <img className='w-[90%] hidden xl:block lg:w-[85%] 2xl:w-[78%] aspect-auto' src={integrate} alt="" />
           <img className='w-[90%] sm:w-[50%]  aspect-auto block xl:hidden ' src={halfintegrate} alt="" />

        </div>
      </div>
      {/* 6th section */}
      <div  className=" w-full flex  gap-10 -mt-[70px] xl:mt-24 items-center bg-[#eeecea] py-[100px] justify-center">  
      <div className='flex flex-col gap-5 xl:gap-0 xl:flex-row w-[90%] lg:w-[90%] 2xl:w-[80%]'>    
      <div className='flex flex-col pt-10 gap-5 w-full items-center xl:items-start xl:w-[40%]'>
        <span className='bold text-[20px] sm:text-[24px] lg:text-[30px] text-center xl:text-start'><FaRankingStar className='hidden xl:block' /> Most trusted reputation and customer experience platform for brands & local businesses</span>
        <span className=' text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] text-center xl:text-start xl:w-[60%]'>Our tool's performance is reflected in its high ratings Google, where it has received praise from satisfied customers.</span>
        <div className='flex gap-2 '>
        <FcGoogle
                        className='text-[40px]  rounded-full h-[40px] text-center  bg-gray-100 ' />
                            <div className=''>
                                <span className='text-sm bold'>Google </span>
                                <span className='flex gap-1'><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /></span>
                            </div>
                           
                        </div>
        </div>

        <div className='flex gap-[10px] flex-wrap justify-center xl:justify-start xl:pl-20 xl:w-[60%]'>
            <div className='h-[325px] w-[300px] 2xl:h-[325px] 2xl:w-[329px] bg-white border  flex flex-col justify-between pb-4 rounded-lg shadow-md'>
            <div className='p-5 pt-6'>
                <h3 className='semibold mb-1'>What do you like best about Elyzian?</h3>
                <p className='text-sm'>It manages all platforms in single dashboard.</p>
                <h3  className='semibold mt-4'>What problems is Elyzian solving and how is that benefiting you?</h3>
                <p className='text-sm mt-2'>With the help of this we can manages all customers interactions of different outlets in single dashboard.
                    </p>
                    </div>
                    <div className='px-5 flex justify-between w-full'>
                        <div className='flex gap-2 '>
                            <div className='w-[40px] rounded-full h-[40px] text-center align-middle bg-gray-100 pt-[8px]'>
                                V
                            </div>
                            <div className=''>
                                <span className='text-sm medium'>Vaibhav </span>
                                <span className='flex gap-1'><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /></span>
                            </div>
                           
                        </div>
                        <FcGoogle
                        className='text-[40px]  rounded-full h-[40px] text-center  bg-gray-100 ' />
                              
                    </div>
            </div>

            <div className='h-[325px] w-[300px] 2xl:h-[325px] 2xl:w-[329px] bg-white border flex flex-col justify-between pb-4 rounded-lg shadow-md'>
            <div className='p-5 pt-6 '>
                
                <p className='text-sm mt-2'>We absolutely love Elyzian! It has made getting reviews from customers so easy and has helped us in getting more reviews more often. This is an amazing tool that we highly recommend to anyone looking to get more customer reviews.
                    </p>
                    </div>
                    <div className='px-5 flex justify-between w-full'>
                        <div className='flex gap-2 '>
                            <div className='w-[40px] rounded-full h-[40px] text-center align-middle bg-gray-100 pt-[8px]'>
                                R
                            </div>
                            <div className=''>
                                <span className='text-sm medium'>Rajiv Agarwal</span>
                                <span className='flex gap-1'><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /></span>
                            </div>
                           
                        </div>
                        <FcGoogle
                        className='text-[40px]  rounded-full h-[40px] text-center  bg-gray-100 ' />
                              
                    </div>
            </div>
            <div className='h-[325px] w-[300px] 2xl:h-[325px] 2xl:w-[329px] bg-white border flex flex-col justify-between pb-4 rounded-lg shadow-md'>
            <div className='p-5 pt-6 '>
                
                <p className='text-sm mt-2'>I was very impressed with how well Elyzian did. I highly recommend this company if you are looking to improve your reviews and feedback. Do not hesitate to sign up and sit back and let them do their thing.
                    </p>
                    </div>
                    <div className='px-5 flex justify-between w-full'>
                        <div className='flex gap-2 '>
                            <div className='w-[40px] rounded-full h-[40px] text-center align-middle bg-gray-100 pt-[8px]'>
                                N
                            </div>
                            <div className=''>
                                <span className='text-sm medium'>Neha Sharma </span>
                                <span className='flex gap-1'><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /></span>
                            </div>
                           
                        </div>
                        <FcGoogle
                        className='text-[40px]  rounded-full h-[40px] text-center  bg-gray-100 ' />
                              
                    </div>
            </div>

            <div className='h-[325px] w-[300px] 2xl:h-[325px] 2xl:w-[329px] bg-white border flex flex-col justify-between pb-4 rounded-lg shadow-md'>
            <div className='p-5 pt-6 '>
                
                <p className='text-sm mt-2'>I absolutely love the customer engagement tools that Elyzian provides! As a business management tool, it is essential for me to be able to track and monitor my outlets across multiple locations. This tool makes it so easy and efficient!
                    </p>
                    </div>
                    <div className='px-5 flex justify-between w-full'>
                        <div className='flex gap-2 '>
                            <div className='w-[40px] rounded-full h-[40px] text-center align-middle bg-gray-100 pt-[8px]'>
                                M
                            </div>
                            <div className=''>
                                <span className='text-sm medium'>Malini Garg </span>
                                <span className='flex gap-1'><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /><FaStar className='text-yellow-400' /></span>
                            </div>
                           
                        </div>
                        <FcGoogle
                        className='text-[40px]  rounded-full h-[40px] text-center  bg-gray-100 ' />
                              
                    </div>
            </div>
        </div>
        </div> 
      </div>


      {/* 7th section */}

     <Compliance />

      {/* 8th section */}
      <Booking />
    
<Footer />
    </div>
  )
}

export default Home
